export enum ConfidenceLevel {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
  UNKNOWN = 'UNKNOWN'
}

export enum SectionStatus {
  ERROR = 'ERROR',
  LOW_CONFIDENCE = 'LOW_CONFIDENCE',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  NONE = 'NONE'
}
